import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8xv92b82sv: FaireBrandEntity = {
  token: "b_8xv92b82sv",
  type: "brand",
  name: "Epic Life  - Designed",
  avatarUrl:
    "https://cdn.faire.com/fastly/bc6ece57ffce113368f2b3cb70f4aeb42054e9f9eefc0009cc10e310e0b6db7d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7f0d53c38ad443647236f85c51b836cd92f5da0ff2bb3348a1424f33d571334b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bc6ece57ffce113368f2b3cb70f4aeb42054e9f9eefc0009cc10e310e0b6db7d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7f0d53c38ad443647236f85c51b836cd92f5da0ff2bb3348a1424f33d571334b.jpeg",
  location: "Ocala, FL, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 33,
  isTopShop: true,
  isInsider: true,
  description:
    "At the heart of our brand is a simple belief: everyone deserves to wear, carry, and celebrate the things they love—no matter their size or style. We began our journey making fun, size-inclusive T-shirts that empower people to express themselves boldly and comfortably. Over time, our creative spark led us to branch out—now you’ll find our designs on everything from waterproof stickers and bookish bookmarks to tote bags and drinkware.\n\nBut our story doesn’t stop at just products. We also own and operate an independent retail bookstore that’s been a beloved community hub for over 17 years. Books are our roots, creativity is our passion, and spreading joy through unique, quality-made gifts is what we do best.\n\nWhether you’re shopping for a curated boutique or a book-loving customer, you’ll always find something to make you smile. Thank you for supporting our small business and helping us share a little more color, comfort, and happiness with the world!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:00.256Z",
    importedBy: "entity-db-cli",
  },
};
